module.exports = __webpack_public_path__ + "static/media/brand-5.3ae69bec.png";